import React, { useEffect, useState } from 'react'
import {
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useNotify,
  required,
  Form,
  Create,
  FormDataConsumer,
  useRedirect,
} from 'react-admin'
import EditIcon from '@mui/icons-material/Edit'
import { Box, Container, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { setResourceProps } from 'src/helper/resourceProps'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { getCurrentWorkUnitOnlyOne } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getCurrentWorkUnitOnlyOne'
import { TreeViewCheck } from 'src/components/uiElements/styledComponents/TreeViewCheck'
import { Modal, Typography, Button, Grid, AlertTitle } from '@mui/material'
import { useQuery } from 'react-query'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { useWatch } from 'react-hook-form'
import { CreditArray } from 'src/components/pages/payment/payment/logic/CreditArray'
import { PaymentTypeArray } from 'src/components/pages/payment/payment/logic/PaymentTypeArray'
import { FormDivider } from 'src/components/uiElements/fields/Divider'
import InfoIcon from '@mui/icons-material/Info'
import { CustomAlert } from 'src/components/uiElements/styledComponents/CustomAlert'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { CurrencyExchangeModal } from 'src/components/pages/payment/payment/logic/CurrencyExchangeModal'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_EDIT } from 'src/helper/Permission'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minHeight: 200,
  minWidth: 500,
  height: 'auto',
  width: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
}

const CreditOrPaymenType = ({
  selectedWorkUnit,
  selectedBusinessUnit,
  rowStyle,
  setRowStyle,
  initialValues,
  setInitialValues,
  extraCostSuccessStates,
  setExtraCostSuccessStates,
}) => {
  const translate = useTranslate()
  const credit_or_payment_type = useWatch({ name: 'credit_or_payment_type' })
  const [openCustomAlertCredit, setOpenCustomAlertCredit] = useState(false)
  const [openCustomAlertPaymentType, setOpenCustomAlertPaymentType] = useState(false)

  useEffect(() => {}, [credit_or_payment_type]) // It is necessary to recharge the watches

  if (credit_or_payment_type === 'CREDIT') {
    return (
      <>
        {/* {credit?.length !== 0 && ( */}
        <Grid item sm={12}>
          <CustomAlert setOpenCustomAlert={setOpenCustomAlertCredit} openCustomAlert={openCustomAlertCredit}>
            <AlertTitle>Creditos a favor</AlertTitle>
            Usted tiene creditos a favor los cuales puede utilizar para pagar <strong>
              parte del monto
            </strong>{' '}
            o el <strong>monto total</strong>.<br />
            Dentro del campo <strong>Importe Total </strong> le dira cuanto es su credito a favor y en el
            campo
            <strong> importe a utilizar </strong> podra ingresar la cantidad de credito a favor que quiere
            utilizar.
            <br />
          </CustomAlert>
        </Grid>
        {/* )} */}
        <Box className='divider_and_button_container'>
          <Box className='divider_and_button_container_button'>
            <Button
              endIcon={<InfoIcon />}
              disabled={openCustomAlertCredit}
              variant='text'
              style={{ backgroundColor: 'transparent' }}
              onClick={() => {
                setOpenCustomAlertCredit(true)
              }}
            />
          </Box>
          <Box className='divider_and_button_container_divider'>
            <FormDivider flex={7} show={true} text='Créditos a Favor' />
          </Box>
        </Box>
        <CreditArray selectedBusinessUnit={selectedBusinessUnit} />
      </>
    )
  }
  if (credit_or_payment_type === 'PAYMENT_TYPE') {
    return (
      <>
        <Grid item sm={12}>
          <CustomAlert
            setOpenCustomAlert={setOpenCustomAlertPaymentType}
            openCustomAlert={openCustomAlertPaymentType}
          >
            <AlertTitle>{translate('ra.field.payment_types')}</AlertTitle>
            {translate('ra.message.instructive_paymen_type')}
          </CustomAlert>
        </Grid>
        <Box className='divider_and_button_container'>
          <Box className='divider_and_button_container_button'>
            <Button
              endIcon={<InfoIcon />}
              disabled={openCustomAlertPaymentType}
              variant='text'
              style={{ backgroundColor: 'transparent' }}
              onClick={() => {
                setOpenCustomAlertPaymentType(true)
              }}
            />
          </Box>
          <Box className='divider_and_button_container_divider'>
            <FormDivider flex={7} show={true} text='Tipos de pago' />
          </Box>
        </Box>
        <PaymentTypeArray
          selectedWorkUnit={selectedWorkUnit}
          selectedBusinessUnit={selectedBusinessUnit}
          rowStyle={rowStyle}
          setRowStyle={setRowStyle}
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          extraCostSuccessStates={extraCostSuccessStates}
          setExtraCostSuccessStates={setExtraCostSuccessStates}
        />
      </>
    )
  }
}

const ApplyInReservationOrItem = ({
  selectedWorkUnit,
  selectedBusinessUnit,
  initialValues,
  extraCostSuccessStates,
  rowStyle,
}) => {
  const translate = useTranslate()
  const redirect = useRedirect()
  const { getValues, control } = useFormContext()
  const credit_or_payment_type = useWatch({ name: 'credit_or_payment_type' })
  const currency = useWatch({ name: 'currency' })
  const business_unit = useWatch({ name: 'business_unit' })
  const credit = useWatch({ name: 'credit' })
  const paymentType = useWatch({ name: 'paymentType' })
  const [hasAmount, setHasAmount] = useState(false)
  const values = getValues()
  const { setIsReservationOption, setPaymentData, paymentData } = usePaymentContext()
  const {
      fields: creditFields
    } = useFieldArray({
      control,
      name: 'credit',
    })
  const areAllExtraCostsSuccess = (payments) => {
    return (
      payments &&
      Array.isArray(payments) &&
      payments?.every(
        (payment) =>
          payment?.extra_cost &&
          Array.isArray(payment?.extra_cost) &&
          payment.extra_cost?.every((cost) => cost?.success === true)
      )
    )
  }

  const validateAmounts = () =>{
    if(credit.some((item) => item.amount_to_pay > item.amount_pending)){
      return false
    }
    return true
  }

  useEffect(() => {
    if (credit_or_payment_type === 'CREDIT') {
      setHasAmount(credit.some((item) => item.amount_to_pay > 0))
      return
    }
    if (credit_or_payment_type === 'PAYMENT_TYPE' && paymentType) {
      setHasAmount(paymentType?.some((item) => item.amount_to_pay > 0) && areAllExtraCostsSuccess(paymentType))
      return
    }
    setHasAmount(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credit, paymentType])

  const saveFormValues = () => {
    const selectedData = {
      work_unit_token: selectedWorkUnit?.token,
      work_unit_id: selectedWorkUnit?.id,
      hash_work_unit: selectedWorkUnit?.hash_work_unit,
      selectedWorkUnit: selectedWorkUnit,
      hash_business_unit: selectedBusinessUnit?.hash_business_unit,
      selectedBusinessUnit: selectedBusinessUnit,
      form_data: {
        ...paymentData?.form_data,
        business_unit: values?.business_unit,
        credit_or_payment_type: values?.credit_or_payment_type,
        currency: values?.currency,
        date:values?.date
      },
      initialValues: initialValues,
      extraCostSuccessStates: extraCostSuccessStates,
      rowStyle: rowStyle
    }

    if (values?.paymentType) {
      let payment = { ...paymentData, ...selectedData }
      payment['form_data'] = { ...payment.form_data, paymentType: values?.paymentType }
      setPaymentData(payment)
    }

    if (values?.credit && values?.credit?.length > 0) {
      let payment = { ...paymentData, ...selectedData }
      payment['form_data'] = { ...payment.form_data, credit: values?.credit }
      setPaymentData(payment)
    }
  }

  const onRedirect = () => {
    redirect('payment')
  }

  useEffect(() => {}, [credit_or_payment_type, currency, business_unit]) // It is necessary to recharge the watches

  if (credit_or_payment_type && currency && business_unit) {
    return (
      <Box display={'flex'} width={'100%'} justifyContent={'center'}>
        <Box display={'flex'} width={'60%'} justifyContent={'space-around'} marginY={'15px'}>
          {(
            <Button
              variant='contained'
              onClick={() => {
                saveFormValues()
                onRedirect()
                setIsReservationOption(true)
              }}
              disabled={(credit_or_payment_type === 'CREDIT' && (!values?.date || !hasAmount || !validateAmounts())) ||
                        (credit_or_payment_type === 'PAYMENT_TYPE' && !hasAmount) 
                      }
            >
              {translate('ra.action.apply_to_reservation')}
            </Button>
          )}

          {credit_or_payment_type === 'PAYMENT_TYPE' && <Button
            variant='contained'
            onClick={() => {
              saveFormValues()
              onRedirect()
              setIsReservationOption(false)
            }}
            disabled={!hasAmount}
          >
            {translate('ra.action.apply_to_item')}
          </Button>}
        </Box>
      </Box>
    )
  }
}

function PaymenRegister() {
  const translate = useTranslate()
  const notify = useNotify()
  const [businessUnits, setBusinessUnits] = useState([])
  const [selectedWorkUnit, setSelectedWorkUnit] = useState(null)
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null)
  const [loadingBusinessUnits, setLoadingBusinessUnits] = useState(false)
  const [openExchangeModal, setOpenExchangeModal] = useState(false)

  const [loadingBusinessUnitToCurrency, setLoadingBusinessUnitToCurrency] = useState(false)
  const [open, setOpen] = useState(false)
  const [expanded, setExpanded] = useState([])
  const [currentWorkUnitToken, setCurrentWorkUnitToken] = useState('')
  const [currentWorkUnit, setCurrentWorkUnit] = useState({})

  setResourceProps(useResourceDefinitions(), useResourceContext())

  const {
    paymentData,
    paymentCurrecies,
    paymentExchanges,
    setPaymentExchanges,
    setPaymentCurrecies,
    setCurrency,
  } = usePaymentContext()

  const [rowStyle, setRowStyle] = useState({})
  const [initialValues, setInitialValues] = useState([
    {
      payment_type: null,
      amount_to_pay: null,
      apply_extra_cost: null,
      card: null, // card props
      financial_entity: null, // card props
      quota: null,
    },
  ])
  const [extraCostSuccessStates, setExtraCostSuccessStates] = useState({})
  const [isEnabled, setIsEnabled] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const allWorkUnits = useQuery('work-unit-all', () => workUnitServices.getByOrderParent(), {
    enabled: isEnabled,
    onSuccess: () => {
      setIsEnabled(false)
    },
  })

  useEffect(() => {
    setIsEnabled(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    ;(async () => {
      if (currentWorkUnitToken && allWorkUnits?.data?.length !== 0) {
        const work_unit = await getCurrentWorkUnitOnlyOne(allWorkUnits.data, currentWorkUnitToken)
        onChangeWorkUnit(work_unit)
      } else {
        setCurrentWorkUnit({})
        setBusinessUnits([])
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken])

  useEffect(() => {
    if (paymentData?.work_unit_token) {
      setCurrentWorkUnitToken(paymentData?.work_unit_token)
    }
    if (paymentData?.hash_work_unit) {
      setCurrentWorkUnitToken(paymentData?.hash_work_unit)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData?.hash_work_unit])

  useEffect(() => {
    if (paymentData?.selectedBusinessUnit) {
      setSelectedBusinessUnit(paymentData?.selectedBusinessUnit)
      getCurrenciesByBusinessUnitById(paymentData?.selectedBusinessUnit?.id)
      getExchangeByBusinessUnitById(paymentData?.selectedBusinessUnit?.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData?.selectedBusinessUnit])

  useEffect(() => {
    if (paymentData?.rowStyle) {
      setRowStyle(paymentData?.rowStyle)
    }
  }, [paymentData?.rowStyle])

  useEffect(() => {
    if (paymentData?.initialValues) {
      setInitialValues(paymentData?.initialValues)
    }
  }, [paymentData?.initialValues])

  useEffect(() => {
    if (paymentData?.extraCostSuccessStates) {
      setExtraCostSuccessStates(paymentData?.extraCostSuccessStates)
    }
  }, [paymentData?.extraCostSuccessStates])

  const getExchangeByBusinessUnitById = async (selectedBusinessUnitId) => {
    try {
      if (!selectedBusinessUnitId) {
        notify('ra.message.has_not_business_unit_to_get_currencies', {
          type: 'error',
        })
        setPaymentExchanges([])
        return
      }
      setLoadingBusinessUnitToCurrency(true)
      const exchanges = await businessUnitServices.exchange_by_business_unit(selectedBusinessUnitId)
      if (exchanges) {
        setPaymentExchanges(exchanges)
      } else {
        notify('ra.message.has_not_currencies_by_business_unit', {
          type: 'error',
        })
        setPaymentExchanges([])
      }
    } catch (error) {
      notify('ra.message.has_not_currencies_by_business_unit', {
        type: 'error',
      })
      setPaymentExchanges([])
    } finally {
      setLoadingBusinessUnitToCurrency(false)
    }
  }

  const getCurrenciesByBusinessUnitById = async (selectedBusinessUnitId) => {
    try {
      if (!selectedBusinessUnitId) {
        notify('ra.message.has_not_business_unit_to_get_currencies', {
          type: 'error',
        })
        setPaymentCurrecies([])
        return
      }
      setLoadingBusinessUnitToCurrency(true)
      const currencies = await businessUnitServices.currencies_by_business_unit(selectedBusinessUnitId)

      if (currencies) {
        setPaymentCurrecies(currencies)
      } else {
        notify('ra.message.has_not_currencies_by_business_unit', {
          type: 'error',
        })
        setPaymentCurrecies([])
      }
    } catch (error) {
      notify('ra.message.has_not_currencies_by_business_unit', {
        type: 'error',
      })
      setPaymentCurrecies([])
    } finally {
      setLoadingBusinessUnitToCurrency(false)
    }
  }


  const onChangeWorkUnit = (work_unit) => {
    if (work_unit) {
      setCurrentWorkUnit(work_unit)
      setSelectedWorkUnit(work_unit)
      return
    }
    setCurrentWorkUnit({})
  }

  const onChangeBusinessUnit = async (e) => {
    const businessUnit = e.target.value
    if (businessUnit) {
      setSelectedBusinessUnit(businessUnit)
      try {
        await Promise.all([
          getCurrenciesByBusinessUnitById(businessUnit?.id),
          getExchangeByBusinessUnitById(businessUnit?.id),
        ])
      } catch (error) {
        console.error(
          'Error fetching getCurrenciesByBusinessUnitById and getExchangeByBusinessUnitById',
          error
        )
      }
    }
  }

  const onChangeCurrency = async (e) => {
    const currencyId = e.target.value
    if (currencyId) {
      setCurrency(paymentCurrecies?.find((currency) => currency.id == currencyId))
    }
  }

   let searchTimeoutBusinessUnit
   const getBusinessUnit = async (user, length = 2) => {
     clearTimeout(searchTimeoutBusinessUnit)
     if (
       (!user?.fantasy_name || user.fantasy_name.length < length) &&
       (!user?.business_name || user.business_name.length < length)
     ) {
       setBusinessUnits([])
       return
     }
     searchTimeoutBusinessUnit = setTimeout(async () => {
       try {
         setLoadingBusinessUnits(true)
         let filter = {}
         if (user?.fantasy_name) {
           filter.fantasy_name__ilike = user?.fantasy_name
         }
         if (user?.business_name) {
           filter.fiscal_data__name__ilike = user?.business_name
         }
         let queryString = `work_unit_id=${currentWorkUnit?.id}`
         const business_unit = await businessUnitServices.business_unit_filter(filter, queryString)
         setBusinessUnits(business_unit)
       } catch (error) {
         setBusinessUnits([])
       } finally {
         setLoadingBusinessUnits(false)
       }
     }, 1000)
   }

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.payment-entity')}>
        <Create>
          <Form id='post_create_form' record={paymentData?.form_data} mode="onBlur">
            <CurrencyExchangeModal
              open={openExchangeModal}
              handleClose={() => setOpenExchangeModal(false)}
              titleModal={translate('ra.title.update_exchange_type')}
            />
            <Grid container item>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <Box sx={style}>
                  <Typography id='modal-modal-title' variant='h6' component='h2'>
                    {translate('ra.title.select_work_unit')}
                  </Typography>
                  <TreeViewCheck
                    checked={currentWorkUnitToken}
                    setChecked={setCurrentWorkUnitToken}
                    nodes={allWorkUnits.data}
                    setExpanded={setExpanded}
                    expanded={expanded}
                    onlyOne={true}
                  />
                </Box>
              </Modal>

              <EditInputsWrap label={translate('ra.field.work_unit')} required md={6} lg={6}>
                {allWorkUnits.isLoading ? (
                  <Skeleton variant='rectangular' width={'100%'} height={50} />
                ) : (
                  <Button
                    sx={{
                      width: '100%',
                      height: '40px',
                    }}
                    onClick={handleOpen}
                    variant='outlined'
                  >
                    {currentWorkUnitToken ? currentWorkUnit?.long_name : translate('ra.action.select')}
                  </Button>
                )}
              </EditInputsWrap>

              <EditInputsWrap label={translate('ra.field.business_unit')} md={6} lg={6} required>
                <MultiAutocompleteInput
                  source={`business_unit`}
                  options={businessUnits}
                  loading={loadingBusinessUnits}
                  optionsText={['fantasy_name', 'fiscal_data_name']}
                  optionValue='id'
                  onSearch={getBusinessUnit}
                  resetOnLoad={false}
                  validate={[required()]}
                  fields={['fantasy_name', 'business_name']}
                  onChange={onChangeBusinessUnit}
                  disableClearable={!Object.keys(currentWorkUnit)}
                  defaultValue={
                    paymentData?.form_data?.business_unit ? paymentData?.form_data?.business_unit : null
                  }
                />
              </EditInputsWrap>
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData?.business_unit) {
                    return (
                      <EditInputsWrap label={translate('ra.field.currency')} md={6} lg={4} required>
                        {loadingBusinessUnitToCurrency ? (
                          <Skeleton variant='rectangular' width={'100%'} height={40} />
                        ) : (
                          <SelectInput
                            size='small'
                            source='currency'
                            options={paymentCurrecies}
                            label=''
                            optionsText={['symbol', 'long_name']}
                            separator=' - '
                            optionValue='id'
                            showSearch
                            validate={[required()]}
                            onChange={onChangeCurrency}
                            defaultValue={
                              paymentData?.form_data?.currency ? paymentData?.form_data?.currency : null
                            }
                          />
                        )}
                      </EditInputsWrap>
                    )
                  }
                }}
              </FormDataConsumer>

              <Grid item md={6} lg={8}>
                <Box display={'flex'} justifyContent={'flex-end'} width={'100%'} paddingX={'20px'}>
                  {paymentExchanges.length > 0 && (
                    <Box display={'flex'}>
                      <Box className='currency_resume'>
                        {paymentExchanges
                          .filter((currency) => !currency?.is_reverse)
                          .map((currency, key) => (
                            <Box key={key}>
                              <Typography component='span' fontWeight='bold'>
                                {currency?.currency_relation?.short_name}-
                                {currency?.currency_to_relation?.short_name}: {currency.value}
                              </Typography>
                            </Box>
                          ))}
                      </Box>
                      {hasPermissionFunction('currency-by-work-unit', PERMISSION_EDIT) && (
                        <Box display={'flex'}>
                          <Button onClick={() => setOpenExchangeModal(true)}>
                            <EditIcon />
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Grid container item>
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData?.currency && formData?.business_unit) {
                    return (
                      <EditInputsWrap
                        label={translate('ra.field.credit_or_payment_type')}
                        md={6}
                        lg={4}
                        required
                      >
                        <SelectInput
                          size='small'
                          source='credit_or_payment_type'
                          options={[
                            { id: 'CREDIT', label: 'CREDITO' },
                            { id: 'PAYMENT_TYPE', label: 'FORMA DE PAGO' },
                          ]}
                          label=''
                          optionsText={['label']}
                          optionValue='id'
                          validate={[required()]}
                          defaultValue={
                            paymentData?.form_data?.credit_or_payment_type
                              ? paymentData?.form_data?.credit_or_payment_type
                              : 'PAYMENT_TYPE'
                          }
                        />
                      </EditInputsWrap>
                    )
                  }
                }}
              </FormDataConsumer>
            </Grid>
            <Box>
              <CreditOrPaymenType
                selectedWorkUnit={selectedWorkUnit}
                selectedBusinessUnit={selectedBusinessUnit}
                rowStyle={rowStyle}
                setRowStyle={setRowStyle}
                initialValues={initialValues}
                setInitialValues={setInitialValues}
                extraCostSuccessStates={extraCostSuccessStates}
                setExtraCostSuccessStates={setExtraCostSuccessStates}
              />
            </Box>
            <ApplyInReservationOrItem
              selectedBusinessUnit={selectedBusinessUnit}
              selectedWorkUnit={selectedWorkUnit}
              initialValues={initialValues}
              extraCostSuccessStates={extraCostSuccessStates}
              rowStyle={rowStyle}
            />
          </Form>
        </Create>
      </CardCommon>
    </Container>
  )
}

export default PaymenRegister
